import { CustomTableSortItems } from 'commons/components/table/sort/custom-table-sorting.model';
import { createContext } from 'react';
import { MaterialDefinition } from 'modules/settings/pods/settings-materials/material-definition.vm';

export interface MaterialDefinitionsListContextProps {
    materials: MaterialDefinition[];
    isLoading: boolean;
    defaultSort: CustomTableSortItems;
    onSortOrderChange: (sortItems: CustomTableSortItems) => void;
    selectedRowIds: Set<string>;
    setSelectedRowIds: React.Dispatch<React.SetStateAction<Set<string>>>;
    selectedMaterials: MaterialDefinition[];
    handleSelectRow: (id: string, selected: boolean) => void;
    clearSelection: VoidFunction;
}

export const MaterialDefinitionsListContext = createContext<MaterialDefinitionsListContextProps | undefined>(undefined);
